@if (loading) {
  <div class="d-flex justify-content-center align-items-center w-100" style="height: 80vh">
    <wre-toolkit-loader></wre-toolkit-loader>
  </div>
}

@if (errorMessage) {
  <div class="row text-center">
    <div class="col">
      <span class="wre-form-error">
        {{ errorMessageInfo }}
      </span>
    </div>
  </div>
}

@if (!loading && roleAudit) {
  <div class="wre-timeline-container">
    <div class="row">
      <div class="col-12 col wre-timeline-toggle d-flex justify-content-end">
        <a
          (click)="reverseHistoryData()"
          [ngClass]="{ sortIconDesc: !this.sortToggle, sortIconAsc: this.sortToggle }">
          Date
          @if (this.sortToggle) {
            <span> Ascending </span>
          }
          @if (!this.sortToggle) {
            <span> Descending </span>
          }
        </a>
      </div>
    </div>
    <div class="wre-timeline">
      <div class="row">
        <div class="col-12 col">
          <ul class="mt-3 wre-timeline-line">
            @for (data of historyData; track data) {
              <li class="wre-timeline-group" [ngClass]="{ hideIt: data.value.length === 0 }">
                <div
                  data-bs-toggle="collapse"
                  [attr.data-bs-target]="'#collapse' + data.title"
                  aria-expanded="true"
                  [attr.aria-controls]="'collapse' + data.title">
                  <span class="badge bg-dark">{{ data.displayName }} </span>
                </div>
                <ul [attr.id]="'collapse' + data.title" class="collapse show">
                  @for (audit of data.value; track audit; let i = $index) {
                    <li class="no-info">
                      <div class="card w-100">
                        <wre-role-history-card
                          [audit]="audit"
                          [title]="data.title + i"></wre-role-history-card>
                      </div>
                    </li>
                  }
                </ul>
              </li>
            }
          </ul>
        </div>
      </div>
    </div>
  </div>
}
